import { FetchClient } from "../../utils/fetchClient";

export async function getEmails(from = "", to = "", subject = "", afterTimeEpoch = 0, beforeTimeEpoch = 0, nextPageToken) {
    return await FetchClient(`/emails/google/gmail?from=${from}&to=${to}&subject=${subject}&afterTimeEpoch=${afterTimeEpoch}&beforeTimeEpoch=${beforeTimeEpoch}&nextPageToken=${nextPageToken}`).GET({})
}

